import type {InputDescription} from './types';


export function ariaDescribedby(node: HTMLElement, inputDescription: InputDescription) {
    if (!!inputDescription) {
        node.setAttribute('aria-describedby', inputDescription.id);
    }
}

